import EventEmitter from 'events'
const eventCollector = new EventEmitter()
export default eventCollector
